exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comment-container {\n  padding: 10px;\n}\n.comment-container:nth-of-type(even) {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.comment-entry {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.comment-holder {\n  width: 80%;\n}\n", ""]);

// exports
